module.exports = __webpack_public_path__ + "img/Skirt-Back-B3-Db-Fc-Ga-Hb-Ia.922493c1.png";